
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import CompanyStory from './components/CompanyStory';
import ServiceArea from './components/ServiceArea';
import ContactInfo from './components/ContactInfo';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://lgconcretepumping.com';

const aboutPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  '@id': `${SITE_URL}/about#webpage`,
  url: `${SITE_URL}/about`,
  name: 'About LG Concrete Pumping & Stone LLC | Otto NC Concrete Contractor',
  description:
    'Learn about LG Concrete Pumping & Stone LLC — a family-owned concrete pumping and stone services company based in Otto, NC, serving Western North Carolina and surrounding regions.',
  isPartOf: { '@id': `${SITE_URL}/#website` },
  about: { '@id': `${SITE_URL}/#business` },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
    { '@type': 'ListItem', position: 2, name: 'About', item: `${SITE_URL}/about` },
  ],
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'LG Concrete Pumping & Stone LLC',
  url: SITE_URL,
  telephone: '+18286341304',
  email: 'LGconcretepumpingandstone@gmail.com',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Otto',
    addressRegion: 'NC',
    postalCode: '28763',
    addressCountry: 'US',
  },
  description:
    'Family-owned concrete pumping and stone services company based in Otto, NC, serving Western North Carolina, North Georgia, and Southwest South Carolina.',
};

const AboutPage = () => {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];
    [aboutPageSchema, breadcrumbSchema, organizationSchema].forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'About LG Concrete Pumping & Stone LLC | Otto NC Concrete Contractor';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Learn about LG Concrete Pumping & Stone LLC — a family-owned concrete pumping and stone services company based in Otto, NC, serving Western North Carolina and surrounding regions.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/about`);

    return () => { scripts.forEach((s) => s.remove()); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <AboutHero />
        <CompanyStory />
        <ServiceArea />
        <ContactInfo />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
